import { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { PointsModalHeader } from "./PointsModalHeader";
import { PointsModalFormWrapper } from "./PointsModalFormWrapper";
import { toast } from "react-toastify";
import { WalletModal } from "../WalletModal/WalletModal";
import { useAuth } from "../../auth";
const PointsModal = ({
  user,
  getUser,
  setOpenPointsModal,
  openTopUpWalletModal,
  setOpenTopUpWalletModal,
  setOpenWalletConfigModal
}) => {
const { currentUser, haveAccess } = useAuth();
const [pointsHistory, setPointsHistory] = useState([]);
const [showClubCash, setShowClubCash] = useState(false);
const [page, setPage] = useState(1);
const [pageSize, setPageSize] = useState(10);
const [total, setTotal] = useState(0);
const [isLoading, setLoading] = useState(false);
const pointsHistoryList = () => {
  setLoading(true)
  axios.get(`${process.env.REACT_APP_API_URL}/user/${user?.uid}/wallet/history?page=${page}&page_size=${pageSize}&cc_only=${showClubCash}`).then((res) => {
    let data = res?.data?.data?.sort((a, b) => moment(b.created_at).utc() - moment(a.created_at).utc())
    .filter(el => el.type === 'DR' ? el.balance_consumed > 0 : el)
  setPointsHistory(data);
  setTotal(res?.data?.total);
  setLoading(false)
  }).catch(err => {
    if (err && err.response && err.response?.data && err.response?.data?.message) {
      toast.error(err.response.data.message);
    } else {
      toast.error("Technical Error, Please Try Again");
    }
    setLoading(false)
  })
}


useEffect(() => {
  if(haveAccess(currentUser, 'wallet_history')) {
    pointsHistoryList()
  } 
  document.body.classList.add("modal-open");
  return () => {
    document.body.classList.remove("modal-open");
  };
}, [showClubCash, page, pageSize]);

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered mw-950px">
          {/* begin::Modal content */}
          <div className="modal-content">
            <PointsModalHeader
              user={user}
              setOpenPointsModal={setOpenPointsModal}
              setOpenTopUpWalletModal={setOpenTopUpWalletModal}
              haveAccess={haveAccess}
              currentUser={currentUser}
              showClubCash={showClubCash}
              setShowClubCash={setShowClubCash}
              setOpenWalletConfigModal={setOpenWalletConfigModal}
            />
            {/* begin::Modal body */}
            <div className="modal-body mx-5 mx-xl-5 my-2 p-4">
              <PointsModalFormWrapper
                user={user}
                setOpenPointsModal={setOpenPointsModal}
                pointsHistory={pointsHistory}
                haveAccess={haveAccess}
                currentUser={currentUser}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                total={total}
                isLoading={isLoading}
              />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
      {
        openTopUpWalletModal?.status && (
          <WalletModal
            user={user}
            getUser={getUser}
            pointsHistoryList={pointsHistoryList}
            openTopUpWalletModal={openTopUpWalletModal}
            setOpenTopUpWalletModal={setOpenTopUpWalletModal}
          />
        )
      }
    </>
  );
};

export { PointsModal };
